<template>
  <div class="container admin-gpx-list">
    <h1 class="hover" @click="$router.push('/admin/events/' + eventId + '/registrations')">← Voltar ao evento</h1>
    <h2 v-if="eventName" class="event-name">{{ eventName }}</h2>
    <h3 class="page-title">Validar Tracklog</h3>

    <div class="filters">
      <label class="chk">
        <input type="checkbox" v-model="onlySuspect" @change="load" />
        Só com suspeitos
      </label>

      <label class="chk">
        <input type="checkbox" v-model="onlyUnreviewed" @change="load" />
        Com pendência de revisão
      </label>

      <span class="badge-counter" v-if="suspectTeams > 0">
        {{ suspectTeams }} equipe(s) com suspeito sem revisão
      </span>
    </div>

    <div v-if="loading" class="muted">Carregando...</div>

    <div v-else>
      <p class="muted" v-if="rows.length === 0">Nenhuma equipe com GPX enviado.</p>

      <table v-else class="gpx-table">
        <thead>
          <tr>
            <th>Equipe</th>
            <th>Prova</th>
            <th>Arquivos</th>
            <th>Tipo</th>
            <th>Veredito</th>
            <th>Revisão</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="u in rows" :key="u.team_id + '-' + u.competition_id" :class="{ 'row-suspect': u.suspect_count > 0 && u.unreviewed_count > 0 }">
            <td class="teamname">{{ u.team_name }} <small class="muted">#{{ u.team_id }}</small></td>
            <td>{{ u.competition_name }}</td>
            <td>
              {{ u.file_count }}
              <span v-if="u.pending_count > 0" class="badge wait">{{ u.pending_count }} na fila</span>
            </td>
            <td>
              <span v-if="u.is_relay" class="badge neutral">revezamento</span>
              <span v-else class="muted">individual</span>
            </td>
            <td>
              <span v-if="u.suspect_count > 0" class="badge bad">{{ u.suspect_count }} suspeito(s)</span>
              <span v-else class="badge ok">ok</span>
            </td>
            <td>
              <div class="review-cell">
                <span :class="teamReview(u).cls">{{ teamReview(u).label }}</span>
                <small v-if="teamReview(u).mixed" class="muted">
                  ✔{{ u.approved_count }} · ✖{{ u.rejected_count }} · {{ u.unreviewed_count }} pend. (de {{ u.file_count }})
                </small>
              </div>
            </td>
            <td>
              <router-link :to="'/admin/gpx/team/' + u.team_id + '/' + u.competition_id" class="link">analisar →</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'admin-gpx-list',

  data() {
    return {
      loading: true,
      rows: [],
      onlySuspect: false,
      onlyUnreviewed: false,
      suspectTeams: 0,
    };
  },

  computed: {
    eventId() { return Number(this.$route.params.eventid); },
    eventName() {
      const ev = this.$store.getters['EventStore/eventInfo'];
      return ev && ev.name ? ev.name : '';
    },
  },

  async created() {
    this.$store.dispatch('EventStore/loadEvent', this.eventId);
    await this.load();
    await this.loadSuspectBadge();
  },

  methods: {
    // Veredito da equipe como um todo (a revisão é aplicada a todos os
    // arquivos da equipe de uma vez). Uma corrida de equipe pode ter vários
    // GPX (revezamento), mas a decisão é única: aprovada ou rejeitada.
    teamReview(u) {
      const n = u.file_count || 0;
      if (n === 0) return { label: '—', cls: 'muted', mixed: false };
      if (u.approved_count === n) return { label: 'Aprovada', cls: 'badge ok', mixed: false };
      if (u.rejected_count === n) return { label: 'Rejeitada', cls: 'badge bad', mixed: false };
      if (u.unreviewed_count === n) return { label: 'Pendente', cls: 'muted', mixed: false };
      return { label: 'Em revisão', cls: 'badge wait', mixed: true };
    },

    async load() {
      this.loading = true;
      try {
        const params = { eventId: this.eventId };
        if (this.onlySuspect) params.onlySuspect = true;
        if (this.onlyUnreviewed) params.onlyUnreviewed = true;

        const res = await api.getJSONAsync('gpxAdminTeamList', params);
        if (res && !res.error) this.rows = res.rows || [];
      } finally {
        this.loading = false;
      }
    },

    async loadSuspectBadge() {
      const params = { eventId: this.eventId, onlySuspect: true, onlyUnreviewed: true };
      const res = await api.getJSONAsync('gpxAdminTeamList', params);
      if (res && !res.error) this.suspectTeams = (res.rows || []).length;
    },
  },
};
</script>

<style scoped lang="stylus">
.admin-gpx-list
  padding: 1.5em 0

.hover
  cursor: pointer

.event-name
  margin: 0.2em 0 0
  color: #555

.page-title
  margin: 0.1em 0 1em
  color: #17a2b8

.filters
  display: flex
  align-items: flex-end
  gap: 1.4em
  margin-bottom: 1.2em
  flex-wrap: wrap

.filters label
  display: flex
  flex-direction: column
  font-size: 0.85em
  color: #555
  gap: 0.3em

.filters label.chk
  flex-direction: row
  align-items: center
  gap: 0.4em

.filters select
  padding: 0.4em
  border: 1px solid #ccc
  border-radius: 4px
  min-width: 160px

.teamname
  font-weight: 600

.review-cell
  display: flex
  flex-direction: column
  align-items: flex-start
  gap: 0.25em

.badge-counter
  background: #f8d7da
  color: #842029
  padding: 0.4em 0.8em
  border-radius: 16px
  font-size: 0.85em
  font-weight: 600
  align-self: center

.gpx-table
  width: 100%
  border-collapse: collapse

.gpx-table th, .gpx-table td
  text-align: left
  padding: 0.5em 0.6em
  border-bottom: 1px solid rgba(0,0,0,0.08)
  font-size: 0.9em

.gpx-table th
  background: rgba(0,0,0,0.03)

.filename
  max-width: 220px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap

.row-suspect
  background: rgba(248, 215, 218, 0.35)

.badge
  display: inline-block
  padding: 0.15em 0.5em
  border-radius: 4px
  font-size: 0.82em

.badge.ok
  background: #d1e7dd
  color: #0f5132

.badge.bad
  background: #f8d7da
  color: #842029

.badge.wait
  background: #fff3cd
  color: #664d03

.badge.neutral
  background: rgba(0,0,0,0.06)
  color: #555

.muted
  color: #999

.link
  color: #17a2b8
  text-decoration: none

.pager
  margin-top: 1em
  display: flex
  align-items: center
  gap: 0.8em

.pager button
  padding: 0.3em 0.8em
  border: 1px solid #ccc
  border-radius: 4px
  background: white
  cursor: pointer

.pager button:disabled
  opacity: 0.4
  cursor: default
</style>
